interface Dated {
  createdAt: string;
}

/**
 * Последние обращения для карточки дашборда: ждущие ответа команды и
 * ждущие зрителя приходят двумя списками (два алиаса запроса), общий
 * порядок по дате создания, новые сверху.
 */
export function latestRequests<T extends Dated>(
  needsReply: readonly T[] | undefined,
  waitingViewer: readonly T[] | undefined,
  limit: number
): T[] {
  return [...(needsReply ?? []), ...(waitingViewer ?? [])]
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )
    .slice(0, limit);
}
